module.exports = __webpack_public_path__ + "static/media/med_school_rankings.59e6c58b.jpg";